import loadable from '@loadable/component';

export const LazyCashFundGuest = loadable(() => import(/* webpackChunkName: "content/cashfunds/guest" */ './CashFundGuest'));
